// Provenance: repo:tds-reconciliation-portal:frontend/src/components/ChipStrip.tsx
// (ADR-0005) — restyled (ADR-0010). The density-pass geometry carries: the same figures a
// card row spent ~90px on, at ~28px.
import type { ReactNode } from 'react'

import { Money } from './Money'

const fmt = new Intl.NumberFormat('en-IN')

/** A headline figure as one slim inline chip. Same value contract as the old
 *  TotalCard: a numeric value is a count and gets grouped digits; a string is
 *  money and goes through Money, which owns the sign and colour rules. */
export function StatChip({ label, value, hint, colorize }: {
  label: string
  value: string | number
  /** optional breakdown, kept beside the figure in dimmed text */
  hint?: string
  colorize?: boolean
}) {
  return (
    <span className="inline-flex items-baseline gap-1.5 whitespace-nowrap">
      <span className="text-xs font-bold uppercase text-muted-foreground">{label}</span>
      {typeof value === 'number' ? (
        <span className="text-sm font-bold">{fmt.format(value)}</span>
      ) : (
        <Money v={value} bold colorize={colorize} />
      )}
      {hint && <span className="max-w-48 truncate text-xs text-muted-foreground">{hint}</span>}
    </span>
  )
}

/** The strip itself: one wrapping row with clear separation between chips. */
export function ChipStrip({ children }: { children: ReactNode }) {
  return <div className="flex flex-wrap items-baseline gap-x-8 gap-y-1 px-0.5 py-0.5">{children}</div>
}
